import { render } from "./faq2Page.vue?vue&type=template&id=2c9fb270"
import script from "./faq2Page.vue?vue&type=script&lang=js"
export * from "./faq2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__